import APIClient from "../client";
import { buildQueryString } from "../../utils/helpers";

const bookingsAPI = {
  get: (query = {}) => {
    const queryString = buildQueryString(query);
    return APIClient.get(`/booking${queryString}`);
  },
  create: (payload) => {
    return APIClient.post("/booking", payload);
  },
  update: (id, payload) => {
    return APIClient.put(`/booking/${id}`, payload);
  },
  cancel: (id) => {
    return APIClient.patch(`/booking/${id}/cancel`);
  },
  exportPDF: (id) => {
    return APIClient.get(`/export/${id}`, {
      responseType: "blob",
    });
  },
  exportWord: (id) => {
    return APIClient.get(`/export/${id}/note`, {
      responseType: "blob",
    });
  },
};

export default bookingsAPI;
